import { useNavigate } from 'react-router-dom'

import { Box, LinkComponent } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  resourceId: string | number
}

const Link = ({ resourceId }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box justifyContent="flexEnd" width="full" flexDirection="row" textAlign="right">
      <LinkComponent.Touchable
        expand
        onClick={() => {
          navigate(
            navigation.expenses.list.expenses.expenseId.fullPath({
              expense_id: resourceId,
            })
          )
        }}
      >
        {i18n.t('dashboard.todo.approvals.expenses.link_button')}
      </LinkComponent.Touchable>
    </Box>
  )
}

export default Link
